<template>
  <div>
    <ts-loading-banner :loading="loading">
      <form>
        <div class="form-group">
          <label class="control-label"
            >{{ $t('eschool.name') }} <span class="text-danger">*</span>
          </label>
          <input
            v-model="model.event_name"
            type="text"
            class="form-control kh-font"
            :class="{ 'is-invalid': errors.has('event_name') }"
          />
          <div class="invalid-feedback" v-if="errors.has('event_name')">
            {{ errors.first('event_name') }}
          </div>
        </div>
        <div class="form-group">
          <label class="control-label">
            {{ $t('eschool.startDate') }} <span class="text-danger">*</span>
          </label>
          <ts-date-picker-inputs v-model="model.event_start_date" />
          <div style="color:#cc4946;margin:4px 0 0">
            {{ errors.first('event_start_date') }}
          </div>
        </div>
        <div class="form-group">
          <label class="control-label">
            {{ $t('eschool.endDate') }} <span class="text-danger">*</span>
          </label>
          <ts-date-picker-inputs v-model="model.event_end_date" />
          <div style="color:#cc4946;margin:4px 0 0">
            {{ errors.first('event_end_date') }}
          </div>
        </div>
        <div class="form-group">
          <label class="control-label"> {{ $t('eschool.criteria') }} </label>
          <textarea
            v-model="model.event_criteria"
            rows="3"
            class="form-control"
            :class="{ 'is-invalid': errors.has('event_criteria') }"
          ></textarea>
          <div class="invalid-feedback" v-if="errors.has('event_criteria')">
            {{ errors.first('event_criteria') }}
          </div>
        </div>
        <div class="form-group" v-if="!editing">
          <h2 class="ts-capitalize ts-font-semibold ts-underline">
            {{ $t('eschool.createForBranch') }}
            <span class="text-danger">*</span>
          </h2>
          <div class="ts-p-3">
            <ts-checkbox
              v-for="(branch, index) in branch_lists"
              :key="index"
              :value="branch.branch_id"
              v-model="model.branch_id_list"
              >{{ branch.branch_name_en }}</ts-checkbox
            >
            <div
              style="color:#cc4946;margin:4px 0 0"
              v-if="errors.has('branch_id_list')"
            >
              {{ errors.first('branch_id_list') }}
            </div>
          </div>
        </div>
        <div class="form-group">
          <h2 class="ts-capitalize ts-font-semibold ts-underline">
            {{ $t('eschool.receiver') }} <span class="text-danger">*</span>
          </h2>
          <div class="ts-p-3">
            <ts-checkbox v-model="model.is_staff_event">
              {{ $t('eschool.staff') }}
            </ts-checkbox>
            <ts-checkbox v-model="model.is_parent_event">
              {{ $t('eschool.parent') }}
            </ts-checkbox>
            <ts-checkbox v-model="model.is_student_event">
              {{ $t('eschool.student') }}
            </ts-checkbox>
          </div>
          <div
            style="color:#cc4946;margin:4px 0 0"
            v-if="errors.has('receiver')"
          >
            {{ errors.first('receiver') }}
          </div>
        </div>

        <div class="text-right">
          <ts-button @click="cancel()" v-if="editing == true">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button
            class="ml-2"
            color="primary"
            :disabled="saving"
            :waiting="saving"
            @click="update"
            v-if="editing == true"
          >
            {{ $t('update') }}
          </ts-button>
          <ts-button
            class="ml-2"
            color="primary"
            :disabled="saving"
            :waiting="saving"
            @click="save"
            v-else
          >
            {{ $t('save') }}
          </ts-button>
        </div>
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'event-create-form',
  props: ['edit', 'leave'],
  data() {
    return {
      model: {
        branch_id_list: [],
        event_name: '',
        event_start_date: moment().format('DD-MM-YYYY'),
        event_end_date: moment().format('DD-MM-YYYY'),
        event_criteria: '',
        is_staff_event: false,
        is_parent_event: false,
        is_student_event: false
      },
      errors: new Errors(),
      saving: false,
      editing: false,
      loading: false,
      branch_lists: []
    }
  },
  created() {
    this.setEdit()
  },
  methods: {
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'event' })
    },

    async save() {
      this.errors = new Errors()

      const noReceiver =
        !this.model.is_staff_event &&
        !this.model.is_parent_event &&
        !this.model.is_student_event

      const noBranch =
        !this.model.branch_id_list || this.model.branch_id_list.length === 0

      if (noReceiver || noBranch) {
        const errs = {}
        if (noReceiver) {
          errs.receiver = [
            'Please select at least one receiver (Staff, Parent or Student).'
          ]
        }
        if (noBranch) {
          errs.branch_id_list = ['Please select at least one Branch.']
        }
        this.errors = new Errors(errs)
        return
      }

      this.saving = true
      try {
        let response = await this.$store.dispatch('event/create', this.model)
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.errors = new Errors()

      const noReceiver =
        !this.model.is_staff_event &&
        !this.model.is_parent_event &&
        !this.model.is_student_event

      if (noReceiver) {
        this.errors = new Errors({
          receiver: [
            'Please select at least one receiver (Staff, Parent or Student).'
          ]
        })
        return
      }

      this.saving = true
      try {
        let response = await this.$store.dispatch('event/update', this.model)
        this.$toasted.success(response.message)
        this.$router.push({ name: 'event' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async setEdit() {
      if (this.edit === null || this.edit === undefined) {
        this.loading = true
        let response = await this.$store.dispatch('event/getBranch')
        this.branch_lists = response.data
        this.loading = false
        return
      }
      this.errors = new Errors()
      this.model = Object.assign({}, { branch_id_list: [] }, this.edit)
      this.editing = true
    },

    clearForm() {
      this.model.event_name = ''
      this.model.event_start_date = moment().format('DD-MM-YYYY')
      this.model.event_end_date = moment().format('DD-MM-YYYY')
      this.model.event_criteria = ''
      this.model.is_staff_event = false
      this.model.is_parent_event = false
      this.model.is_student_event = false
      this.model.branch_id_list = []
    }
  },
  watch: {
    leave: {
      handler() {
        if (this.leave) {
          this.clearForm()
          this.editing = false
        }
      }
    },
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
